import React, { useEffect, useState } from 'react'
import { Collapse, Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material'
import { Text } from '../text'
import { observer } from 'mobx-react-lite'

interface AlertProps extends MuiAlertProps {
  dismiss?: any
  open: boolean
  text: string
  delay?: number
}

export const Alert = observer((props: AlertProps) => {
  const { open, text, dismiss, severity, delay = 10000 } = props

  let timer

  useEffect(() => {
    if (delay !== undefined && delay > 0) {
      timer = setTimeout(() => {
        dismiss()
      }, delay)
    }
  }, [delay])

  const handleClose = () => {
    clearTimeout(timer)
    dismiss()
  }

  return (
    <Collapse
      sx={{
        '& .MuiCollapse-wrapperInner': {
          justifyContent: 'center',
          display: 'flex',
        },
      }}
      style={{ justifyContent: 'center', display: 'flex' }}
      in={open}
    >
      <MuiAlert
        sx={{
          mb: 0.5,
          maxWidth: '632px',
          minWidth: '400px',
          width: '100%',
          border: '1px solid rgba(0,0,0,.1)',
          borderRadius: 3,
          alignSelf: 'center',
          '& .MuiAlert-message': {
            alignSelf: 'center',
          },
        }}
        severity={severity as 'success' | 'info' | 'warning' | 'error'}
        onClose={handleClose}
      >
        <Text text={text} variant="body2Medium" />
      </MuiAlert>
    </Collapse>
  )
})
